import { render, staticRenderFns } from "./restore-password.vue?vue&type=template&id=7e62ad46&"
import script from "./restore-password.vue?vue&type=script&lang=js&"
export * from "./restore-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports